import type { CSSProperties } from 'react'

import { Toaster as Sonner, type ToasterProps } from 'sonner'
import { CircleCheckIcon, InfoIcon, TriangleAlertIcon, OctagonXIcon, Loader2Icon } from 'lucide-react'

const Toaster = ({ ...props }: ToasterProps) => {
    return (
        <Sonner
            theme='dark'
            className='toaster group'
            icons={{
                success: <CircleCheckIcon className='size-4 text-emerald-400' />,
                info: <InfoIcon className='size-4 text-sky-400' />,
                warning: <TriangleAlertIcon className='size-4 text-amber-400' />,
                error: <OctagonXIcon className='size-4 text-rose-400' />,
                loading: <Loader2Icon className='size-4 animate-spin' />
            }}
            style={
                {
                    '--normal-bg': 'var(--popover)',
                    '--normal-text': 'var(--popover-foreground)',
                    '--normal-border': 'var(--border)',
                    '--border-radius': 'var(--radius)'
                } as CSSProperties
            }
            {...props}
        />
    )
}

export { Toaster }
